import { ADOBE_BOARD_ERROR_EVENT_KEY } from "../../../../../../services/analytics/constants";

export const boardPageNotFound = state => ({
  ...state,
  trackPage: {
    ...state.trackPage,
    events: [ADOBE_BOARD_ERROR_EVENT_KEY]
  }
});
